"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CosmosValidatorsManager = void 0;
const cache_1 = require("@ledgerhq/live-network/cache");
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const logs_1 = require("@ledgerhq/logs");
const chain_1 = __importDefault(require("./chain/chain"));
class CosmosValidatorsManager {
    constructor(currency, options) {
        this.cacheValidators = (0, cache_1.makeLRUCache)(() => __awaiter(this, void 0, void 0, function* () {
            const url = `${this._endPoint}/cosmos/staking/${this._version}/validators?status=BOND_STATUS_BONDED&pagination.limit=175`;
            const { data } = yield (0, network_1.default)({
                url,
                method: "GET",
            });
            const validators = data.validators.map(validator => {
                const commission = parseFloat(validator.commission.commission_rates.rate);
                return {
                    validatorAddress: validator.operator_address,
                    name: validator.description.moniker,
                    tokens: parseFloat(validator.tokens),
                    votingPower: 0,
                    commission,
                    estimatedYearlyRewardsRate: 0,
                };
            });
            return validators;
        }), () => this._currency.id);
        this.getValidators = () => __awaiter(this, void 0, void 0, function* () {
            // validators need the rewardsState ONLY to compute voting power as
            // percentage instead of raw uatoms amounts
            return yield this.cacheValidators();
        });
        this.hydrateValidators = (validators) => {
            (0, logs_1.log)(`${this._currency.id}/validators`, "hydrate " + validators.length + " validators");
            this.cacheValidators.hydrate("", validators);
        };
        this._currency = currency;
        this._crypto = (0, chain_1.default)(currency.id);
        this._endPoint = this._crypto.lcd;
        this._version = this._crypto.version;
        this._minDenom = currency.units[1].code;
        if (options === null || options === void 0 ? void 0 : options.endPoint) {
            this._endPoint = options.endPoint;
            this._minDenom = currency.units[1].code;
        }
        if (options === null || options === void 0 ? void 0 : options.rewardsState) {
            this._rewardsState = options.rewardsState;
        }
    }
}
exports.CosmosValidatorsManager = CosmosValidatorsManager;
//# sourceMappingURL=CosmosValidatorsManager.js.map